import React, { Component } from 'react';
import logger from '../utils/logger';

class AsyncErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      isNetworkError: false,
      isAuthError: false
    };
  }

  static getDerivedStateFromError(error) {
    // Determine error type
    const isNetworkError = error.message?.includes('fetch') || 
                          error.message?.includes('network') || 
                          error.message?.includes('Network');
    
    const isAuthError = error.message?.includes('401') || 
                       error.message?.includes('403') || 
                       error.message?.includes('unauthorized') ||
                       error.message?.includes('Unauthorized');
    
    return { 
      hasError: true,
      isNetworkError,
      isAuthError
    };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('AsyncErrorBoundary caught an error:', error, errorInfo);
    this.setState({ error });
  }

  handleRetry = () => {
    this.setState({ 
      hasError: false, 
      error: null,
      isNetworkError: false,
      isAuthError: false
    });
    
    // If it's an auth error, redirect to login
    if (this.state.isAuthError) {
      window.location.href = '/account?tab=login';
    }
  };

  render() {
    if (this.state.hasError) {
      const { isNetworkError, isAuthError } = this.state;
      
      return (
        <div className="card p-6 text-center max-w-md mx-auto my-8">
          <svg 
            className={`w-12 h-12 mx-auto mb-4 ${
              isNetworkError ? 'text-yellow-500' : 
              isAuthError ? 'text-orange-500' : 
              'text-red-500'
            }`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            {isNetworkError ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" />
            ) : isAuthError ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            )}
          </svg>
          
          <h3 className="text-lg font-semibold text-primaryText mb-2">
            {isNetworkError ? 'Connection Problem' : 
             isAuthError ? 'Authentication Required' : 
             'Something Went Wrong'}
          </h3>
          
          <p className="text-secondaryText mb-4">
            {isNetworkError ? 'Please check your internet connection and try again.' : 
             isAuthError ? 'Your session has expired. Please log in again.' : 
             'An unexpected error occurred. Please try again.'}
          </p>
          
          <button
            onClick={this.handleRetry}
            className="btn-primary px-6 py-2"
          >
            {isAuthError ? 'Go to Login' : 'Try Again'}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AsyncErrorBoundary;